import React from 'react';
import { Avatar } from '../../shared/Avatar';
import { MasteryBar } from '../../shared/MasteryBar';
import type { SchoolData } from './types';
interface SchoolDetailPanelProps {
  school: SchoolData;
}
export function SchoolDetailPanel({
  school
}: SchoolDetailPanelProps) {
  return <div className="space-y-6" data-id="element-6486">
      <div className="grid grid-cols-3 gap-3" data-id="element-6487">
        <div className="bg-purple-50 rounded-lg p-3 text-center" data-id="element-6488">
          <div className="text-2xl font-bold text-purple-700" data-id="element-6489">
            {school.learnerCount}
          </div>
          <div className="text-xs text-purple-600" data-id="element-6490">Leerlingen</div>
        </div>
        <div className="bg-indigo-50 rounded-lg p-3 text-center" data-id="element-6491">
          <div className="text-2xl font-bold text-indigo-700" data-id="element-6492">
            {school.teacherCount}
          </div>
          <div className="text-xs text-indigo-600" data-id="element-6493">Docenten</div>
        </div>
        <div className="bg-emerald-50 rounded-lg p-3 text-center" data-id="element-6494">
          <div className="text-2xl font-bold text-emerald-700" data-id="element-6495">
            {school.avgMastery}%
          </div>
          <div className="text-xs text-emerald-600" data-id="element-6496">Gem. beheersing</div>
        </div>
      </div>

      {school.teachers.length > 0 && <div data-id="element-6497">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-6498">Docenten</h3>
          <div className="space-y-1" data-id="element-6499">
            {school.teachers.map(t => <div key={t.id} className="flex items-center gap-2 py-1.5" data-id="element-6500">
                <Avatar name={t.name} data-id="element-6501" />
                <span className="text-sm text-gray-700" data-id="element-6502">{t.name}</span>
              </div>)}
          </div>
        </div>}

      {school.learners.length > 0 && <div data-id="element-6503">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-6504">
            Leerlingen
          </h3>
          <div className="space-y-2" data-id="element-6505">
            {school.learners.map(learner => <div key={learner.id} className="flex items-center justify-between py-2 border-b border-gray-50 last:border-0" data-id="element-6506">
                <div className="flex items-center gap-2" data-id="element-6507">
                  <Avatar name={learner.name} data-id="element-6508" />
                  <div data-id="element-6509">
                    <div className="text-sm text-gray-800" data-id="element-6510">{learner.name}</div>
                    <div className="text-xs text-gray-400" data-id="element-6511">
                      {learner.account && 'grade' in learner.account ? `Groep ${learner.account.grade}` : '—'}{' '}
                      · {learner.sessionCount} sessies
                    </div>
                  </div>
                </div>
                <MasteryBar value={learner.avgMastery || 0} data-id="element-6512" />
              </div>)}
          </div>
        </div>}
    </div>;
}